/**
 * Generated file, do not edit directly!
 */

/** Timings define the duration of an animation. */

const Instant = {
  /** Value: 0. */
  Default: 0,
};
const Offset = {
  /** Value: 0.02. */
  Short: 0.02,
  /** Value: 0.03. */
  Medium: 0.03,
  /** Value: 0.1. */
  Long: 0.1,
  /** Value: 0.05. */
  Default: 0.05,
};
const Fast = {
  /** Value: 0.15. */
  Quick: 0.15,
  /** Value: 0.17. */
  Default: 0.17,
  /** Value: 0.2. */
  Moderate: 0.2,
};
const Base = {
  /** Value: 0.25. */
  Quick: 0.25,
  /** Value: 0.3. */
  Default: 0.3,
  /** Value: 0.35. */
  Moderate: 0.35,
};
const Slow = {
  /** Value: 0.4. */
  Default: 0.4,
  /** Value: 0.6. */
  Moderate: 0.6,
  /** Value: 0.8. */
  Gentle: 0.8,
};
const Slowest = {
  /** Value: 1. */
  Default: 1,
  /** Value: 1.2. */
  Moderate: 1.2,
  /** Value: 1.5. */
  Gentle: 1.5,
};
export default {
  Instant,
  Offset,
  Fast,
  Base,
  Slow,
  Slowest,
};
